<div
  class="header_container"
  id="header_container"
  [ngClass]="{ 'menu-open': isMenuOpen() }"
>
  <div class="mobile_header">
    <button
      type="button"
      aria-label="mobile navigation"
      class="burger-button"
      [matMenuTriggerFor]="mobileNoAuthMenu"
      (menuOpened)="menuOpened()"
      (menuClosed)="menuClosed()"
      #menuTrigger="matMenuTrigger"
    >
      <mat-icon>{{ isMenuOpen() ? 'close' : 'menu' }}</mat-icon>
    </button>

    <a href="/" class="handyhand_logo_header">
      <img
        class="logo_in_header"
        src="https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/webp/hh_logo_blue.webp"
        alt="logo"
        width="130"
        height="30"
      />
    </a>

    <div class="header_search_container rm-mobile-logo">
      @if (!isSearchVisible()) {
        <a (click)="toggleSearch($event)" class="link">
          <mat-icon
            fontIcon="search"
            style="
              color: var(--grey_7);
              font-size: 35px;
              height: 35px;
              width: 35px;
            "
          ></mat-icon>
        </a>
        @if (isLoggedIn()) {
          <button
            class="back_to_platform blue_button handyhand_button"
            (click)="externalService.goToLanding()"
          >
            {{ 'NAVIGATION.BTN.BACK_TO_PLATFORM' | translate }}
          </button>
        } @else {
          <button
            style="background-color: transparent"
            aria-label="Opret opgave"
          >
            <a
              (click)="externalService.goToCreateTask()"
              class="create_task_circle_cta_mobile"
              aria-label="Opret en opgave"
            >
              <mat-icon>add</mat-icon>
            </a>
          </button>
        }
      } @else {
        <div class="search_inner animated fadeIn">
          <div class="search_holder">
            <global-search-engine
              class="header_search_input"
              [placeHolderText]="
                'GENERAL.HEADER_SEARCH_PLACEHOLDER' | translate
              "
              [autoFocus]="true"
            ></global-search-engine>
          </div>

          <button class="close_search" (click)="toggleSearch($event)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      }
    </div>

    <mat-menu
      #mobileNoAuthMenu="matMenu"
      yPosition="below"
      xPosition="after"
      style="border-radius: 0"
      class="mobile_nav_no_auth"
    >
      <button
        class="mobile_menu_item mobile_nav_items"
        mat-menu-item
        (click)="
          isMenuOpen.set(false);
          menuTrigger.closeMenu();
          navigateTo('kategorier')
        "
      >
        {{ 'GENERAL.BTN.CATS' | translate }}
      </button>

      @if (!isLoggedIn()) {
        <a
          class="mobile_menu_item mobile_nav_items"
          (click)="$event.stopPropagation(); openLoginPage()"
          mat-menu-item
        >
          {{ 'NAVIGATION.TXT.LOGIN' | translate }}
        </a>
        <a
          class="mobile_menu_item mobile_nav_items"
          (click)="$event.stopPropagation(); openSignupPage()"
          mat-menu-item
        >
          {{ 'NAVIGATION.TXT.SIGN_UP' | translate }}
        </a>
      }

      <a
        class="mobile_menu_item"
        [href]="externalService.tasksUrl"
        mat-menu-item
      >
        <div class="mobile_nav_items">
          {{ 'NAVIGATION.TXT.SEE_TASKS' | translate }}
        </div>
      </a>
      <a
        class="mobile_menu_item"
        [href]="'how-it-works' | seoRoute"
        mat-menu-item
      >
        <div class="mobile_nav_items">
          {{ 'NAVIGATION.TXT.HOW_IT_WORKS' | translate }}
        </div>
      </a>
      @if (country === 'dk') {
        <button
          class="mobile_menu_item gtm_happyhelper_refer_cleaning_mobile_menu"
          (click)="$event.stopPropagation(); goToUserHappyHelper()"
          mat-menu-item
        >
          <div style="display: block" class="mobile_nav_items">
            {{ 'GENERAL.CLEANING_SUBSCRIPTION' | translate }}
          </div>
        </button>
      }

      <a class="mobile_menu_item" [href]="'about-us' | seoRoute" mat-menu-item>
        <div class="mobile_nav_items">
          {{ 'NAVIGATION.TXT.ABOUT_US' | translate }}
        </div>
      </a>
      <a
        class="mobile_menu_item"
        [href]="externalService.landingUrl + ('help' | route)"
        mat-menu-item
      >
        <div class="mobile_nav_items">
          {{ 'GENERAL.HELP' | translate | titlecase }}
        </div>
      </a>
      <a
        class="mobile_menu_item"
        [href]="'damage-compensation' | seoRoute"
        mat-menu-item
      >
        <div class="mobile_nav_items">
          {{ 'GENERAL.DAMAGE_COMPENSATION' | translate | titlecase }}
        </div>
      </a>
      <button
        class="mobile_menu_item"
        (click)="$event.stopPropagation(); switchMobileLanguage()"
        mat-menu-item
      >
        <div style="display: block" class="mobile_nav_items">
          {{ 'PAGES.LANDING.LANG_SWITCH' | translate }}

          <span
            style="
              margin-top: 9px;
              margin-right: 23px;
              font-size: 20px;
              line-height: 1;
            "
            id="language_config_flag"
            aria-label="skift sprog flag"
          >
            {{ reversedFlag() }}
          </span>
        </div>
      </button>
    </mat-menu>
  </div>

  <div class="desktop_header">
    <div class="desktop_header_left">
      <a href="/" class="handyhand_logo_header">
        <img
          class="logo_in_header"
          ngSrc="https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/webp/hh_logo_blue.webp"
          alt="logo"
          width="130"
          height="30"
          priority
        />
      </a>

      @if (isOddSize()) {
        <a
          (click)="externalService.goToCreateTask()"
          class="create_task_circle_cta_mobile"
          aria-label="Opret en opgave"
        >
          <mat-icon>add</mat-icon>
        </a>
      } @else {
        <button
          class="call_to_action_create_task"
          (click)="externalService.goToCreateTask()"
        >
          {{ 'NAVIGATION.TXT.CREATE_TASK' | translate }}
        </button>
      }

      <app-vertical-link-box-component></app-vertical-link-box-component>

      @if (!isOddSize()) {
        <a class="link link_how_to" [href]="'how-it-works' | seoRoute">
          {{ 'NAVIGATION.TXT.HOW_IT_WORKS' | translate }}
        </a>
      }
    </div>

    <div class="desktop_header_right">
      <div class="header_search_container">
        @if (!isSearchVisible()) {
          <a (click)="toggleSearch($event)" class="desktop_search_icon">
            <mat-icon fontIcon="search"></mat-icon>
            <span class="desktop_search_label">{{
              'NAVIGATION.TXT.SEARCH_SITE' | translate
            }}</span>
          </a>
        } @else {
          <div class="search_inner animated fadeIn widen_search_bar">
            <div class="search_holder">
              <global-search-engine
                class="header_search_input"
                [placeHolderText]="
                  'NAVIGATION.TXT.SEARCH_PLACEHOLDER' | translate
                "
                [autoFocus]="true"
              />
            </div>
            <button class="close_search" (click)="toggleSearch($event)">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        }
      </div>
      <nav
        class="desktop_header_right_inner"
        [ngClass]="{ shrink_non_search_bar: isSearchVisible() }"
      >
        <a class="nav-link" [href]="externalService.tasksUrl">
          {{ 'NAVIGATION.TXT.SEE_TASKS' | translate }}
        </a>

        <span class="nav-divider"></span>

        @if (isLoggedIn()) {
          <button
            class="back_to_platform blue_button handyhand_button"
            (click)="externalService.goToLanding()"
          >
            {{ 'NAVIGATION.BTN.BACK_TO_PLATFORM' | translate }}
          </button>
        } @else {
          <a class="nav-link" (click)="openSignupPage()">
            {{ 'NAVIGATION.TXT.SIGN_UP' | translate }}
          </a>
          <a class="nav-link nav-link--login" (click)="openLoginPage()">
            {{ 'NAVIGATION.TXT.LOGIN' | translate }}
          </a>
        }

        <div class="language_select" (click)="toggleDropdown()">
          <span
            class="flag-icon"
            [attr.aria-label]="language().nativeName"
            style="font-size: 18px; line-height: 1"
          >
            {{ language().flag }}
          </span>

          <mat-icon>arrow_drop_down</mat-icon>

          @if (isDropdownOpen()) {
            <div class="custom-dropdown">
              @for (item of languages; track item.code) {
                <div class="select_row" (click)="setLanguage(item, true)">
                  <p>
                    <span style="margin-right: 8px">{{ item.flag }}</span>
                    {{ item.nativeName }}
                  </p>
                </div>
              }
            </div>
          }
        </div>
      </nav>
    </div>
  </div>
</div>
